export default __webpack_public_path__ + "static/media/busSign.c0b67bbe.svg";